var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 36 30",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0.9,
    x2: 37.9778,
    y1: 3.37505,
    y2: 9.26594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7a28f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#f9d6ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbfefc"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.31613 14.8996 7.3035-14.8996h6.94977l-2.8233 6.40981-.2206.62471c-.2464.84167-.4495 1.94153-.0641 2.5109.3412.50408.8701.86958 1.3107 1.10808 3.8212 1.4357 6.5356 5.0789 6.5356 9.3464 0 5.5229-4.546 10-10.1539 10-5.60777 0-10.1538-4.4771-10.1538-10 0-1.621.391644-3.1519 1.08683-4.506.0572-.1996.13325-.3983.2293-.5943zm23.73007 4.9035c0 3.54-1.3199 6.7764-3.5013 9.258 1.3061.6024 2.7639.939 4.3014.939 5.6079 0 10.1539-4.4771 10.1539-9.9999 0-4.1597-2.5789-7.7262-6.248-9.2334-.3517-.2022-.826-.5504-1.198-1.09993-.6025-.89015-.1323-2.83682-.0218-3.25372l2.7287-6.41290586h-6.9497l-4.3695 8.98546586c3.1217 2.59589 5.1043 6.47859 5.1043 10.81739z",
    fill: "url(#a)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.b47110ab4509d04a460387925678a15d.svg";
export { ForwardRef as ReactComponent };